import { BoatSVG } from "./BoatSVG";
export default BoatSVG;
